import type { FilterConfig } from '#types/config/components/filter'
import type { RecursivePartial } from '#types/utils'

export default {
  image: {
    height: '16',
    width: '54'
  }
} satisfies RecursivePartial<FilterConfig['option']['checkbox']>
